<template>
    <div class="businessCenter">
        <div class="banner_top">
            <img :src="this.sylbAddress" alt="" />
        </div>
        <div class="widthrules">
            <div class="product_box">
                <!-- 菜单 -->
                <div class="product_menu">
                    <el-tooltip effect="dark" :content="tooltip_menu_title" placement="left" :disabled="!isShowTooltip">
                        <!-- 菜单顶部大标题 -->
                        <div class="product_menu_title" @mouseenter="visibilityChange($event)">
                            <!-- {{ breadcrumb_item1 }} -->
                        </div>
                    </el-tooltip>
                    <!-- 菜单下面小标题 -->
                    <div class="product_menu_content">
                        <div v-for="item in businessDHTreeList" :key="item.menuId">
                            <el-tooltip effect="dark" :content="tooltip_li_f" placement="left" :disabled="!isShowTooltip">
                                <!-- @click="showInfos(item)" -->
                                <div 
                                    class="li_f"
                                    :class="{ active: selected === item.menuId }"
                                    v-on:mouseover="handleMouseOver(item.guideZw)"
                                    @mouseenter="visibilityChange($event)"
                                >
                                    {{ item.guideZw }}
                                </div>
                            </el-tooltip>
                            <div v-for="ite in item.gList" :key="ite.menuId">
                                <el-tooltip effect="dark" :content="tooltip_li_c" placement="left" :disabled="!isShowTooltip">
                                    <div
                                        v-show="ite.backup !== '1'"
                                        class="li_c"
                                        @click="showInfos(ite)"
                                        :class="{ active: selected === ite.menuId }"
                                        v-on:mouseover="handleMouseOver2(ite.guideZw)"
                                        @mouseenter="visibilityChange($event)"
                                    >
                                        {{ ite.guideZw }}
                                    </div>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 详情 -->
                <div class="product_details">
                    <div class="product_details_title">
                        <el-breadcrumb separator-class="el-icon-arrow-right" class="more">
                            <el-breadcrumb-item :to="{ path: '/' }">{{ breadcrumb_item0 }}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{ breadcrumb_item1 }}</el-breadcrumb-item>
                            <!-- <el-breadcrumb-item>{{ operationMenuTitle }}</el-breadcrumb-item> -->
                            <!-- <el-breadcrumb-item v-for="(item, index) in $route.matched" :key="index">{{ item.meta.title }}</el-breadcrumb-item> -->
                            <el-breadcrumb-item>{{ activetitle1 }}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{ activetitle }}</el-breadcrumb-item>
                        </el-breadcrumb>
                        <div class="title_more">{{ activetitle }}</div>
                    </div>
                    <div class="product_details_content">
                        <div class="ql-container ql-snow">
                            <div class="ql-editor" style="width:890px;">
                                <div v-html="htmlText"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <v-footer></v-footer> -->
    </div>
</template>

<script>
// import vFooter from '../common/footer.vue';
import { gwGetSYLBList, gwGetBusinessDHTreeList, gwGetBusinessContentList, gwGetMenuList } from '@/api/index';
export default {
    name: 'businessCenter',
    // components: {
    //     vFooter
    // },
    data() {
        return {
            tooltip_menu_title: '',
            tooltip_li_f: '',
            tooltip_li_c: '',
            isShowTooltip:false,
            breadcrumb_item0: '',
            breadcrumb_item1: '',
            operationMenuTitle: '',
            languageType: '1',
            sylbAddress: '',
            businessDHTreeList: [],
            selected: null,
            htmlText: '',
            activetitle:'',
            activetitle1:'',
            indexs:''
        };
    },
    watch: {
        $route(to, from){
            this.indexs = this.$route.query.order - 1;
            this.gwGetBusinessContentList(this.$route.query.order);
            this.gwGetBusinessDHTreeList()
        }
    },
    created() {
        if(this.$route.query.params.order){
            this.indexs = this.$route.query.params.order - 1;
        }else{
            this.indexs = this.$route.query.params.ywbktpOrder - 1;
        }
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        window.addEventListener('setItem', () => {
            if (this.$route.path == '/businessArea/operation') {
                this.languageType = sessionStorage.getItem('languageType');
                this.gwGetBusinessDHTreeList();
                this.gwGetMenuList();
            }
        });
        this.gwGetSYLBList();
        this.gwGetBusinessDHTreeList();
        this.gwGetMenuList();
    },
    methods: {
        gwGetMenuList() {
            let params = {
                language: this.languageType
            };
            gwGetMenuList(params).then(res => {
                // console.log('导航加载tree参数必填语言',res.obj)
                this.breadcrumb_item0 = res.obj.menuList[0].guideZw;
                this.breadcrumb_item1 = res.obj.menuList[1].guideZw;
                this.operationMenuTitle = res.obj.menuList[1].children[0].guideZw;
                this.tooltip_menu_title = this.operationMenuTitle;
            });
        },
        visibilityChange(event) {
            const ev = event.target;
            const ev_weight = ev.scrollWidth; // 文本的实际宽度   scrollWidth：对象的实际内容的宽度，不包边线宽度，会随对象中内容超过可视区后而变大。
            const content_weight = ev.clientWidth;// 文本的可视宽度 clientWidth：对象内容的可视区的宽度，不包滚动条等边线，会随对象显示大小的变化而改变。
            // const content_weight = this.$refs.tlp.$el.parentNode.clientWidth; // 文本容器宽度(父节点)
            if (ev_weight > content_weight) {
                // 实际宽度 > 可视宽度  文字溢出
                this.isShowTooltip = true;
            } else {
                // 否则为不溢出
                this.isShowTooltip = false;
            }
        },
        gwGetSYLBList() {
            let params = {
                language: this.languageType,
                type: '2'
            };
            gwGetSYLBList(params).then(res => {
                this.sylbAddress = res.obj[0].sylbAddress
            });
        },
        showInfos(row) { // 点击菜单切换数据
            this.selected = row.menuId;
            this.activetitle = row.guideZw;
            this.activetitle1 = row.backup2;
            this.gwGetBusinessContentList(row.menuId);
        },
        handleMouseOver(e){
            this.tooltip_li_f = e;
        },
        handleMouseOver2(e){
            this.tooltip_li_c = e;
        },
        showParams(row) { // 根据跳转传参刷新页面数据
            this.selected = Number(this.params) - 1;
            if (this.selected == 1) { // 选择的天然气
                this.activetitle = row[this.selected].gList[0].guideZw;
                this.selected = row[this.selected].gList[0].menuId;
            } else { // 选择的氢气或充电
                this.activetitle = row[this.selected].gList[1].guideZw;
                this.selected = row[this.selected].gList[1].menuId;
            }
            let key = this.selected;
            this.gwGetBusinessContentList(key);
        },
        gwGetBusinessDHTreeList() {
            let params = {
                language: this.languageType
            };
            gwGetBusinessDHTreeList(params).then(res => {
                // console.log('查询业务导航tree', res.obj,this.indexs);
                if(this.indexs){
                    this.activetitle1 = res.obj[this.indexs].guideZw;
                }else{
                    this.activetitle1 = res.obj[0].guideZw;
                }
               
                this.businessDHTreeList = res.obj;
                if (this.$route.query.params.ywbktpOrder) { // 从首页跳转过来的
                    this.params = JSON.parse(this.$route.query.params.ywbktpOrder);
                    this.showParams(res.obj);
                } else if (this.$route.query.params.order) { // 从顶部导航跳转过来
                    this.params = JSON.parse(this.$route.query.params.order);
                    this.showParams(res.obj);
                } else { // 刷新页面
                    this.gwGetBusinessContentList(res.obj[0].gList[1].menuId);
                    this.selected = res.obj[0].gList[1].menuId;
                    this.activetitle = res.obj[0].gList[1].guideZw;
                }
            });
        },
        gwGetBusinessContentList(id) {
            let params = {
                language: this.languageType,
                busMenuId: id
            };
            gwGetBusinessContentList(params).then(res => {
                // console.log('查询业务内容根据导航ID与语言类型', res.obj);
                this.htmlText = res.obj.businessA;
            });
        }
    }
};
</script>

<style scoped lang="less">
@deep: ~'>>>';
.businessCenter {
    .banner_top {
        width: 100%;
        margin: auto;
        margin-bottom: -32px;
        img {
            width: 100%;
        }
    }
    .product_box {
        background: #fff;
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: space-between;
        width: 1200px;
        margin: 0px auto 0px auto;
        padding: 20px 20px 30px 20px;
        overflow: hidden;
        // zoom: 1;
        .product_menu {
            width: 22.4138%;
            // width: 220px;
            margin: 0px 0px 0px 0px;
            padding: 0px 0px 0px 0px;
            overflow: hidden;
            zoom: 1;
            .product_menu_title {
                text-overflow: ellipsis;  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/ 
                white-space: nowrap;   /* nowrap:规定段落中的文本不进行换行   */ 
                overflow: hidden;
                width: 100%;
                height: 55px;
                line-height: 50px;
                float: left;
                color: #023e7a;
                font-size: 24px;
                font-weight: bold;
                position: relative;
                z-index: 2;
            }
            .product_menu_content {
                width:99%;
                float: left;
                border-top: 1px solid #e6e6e6;
                border-right:2px solid #e6e6e6;
                border-left: 1px solid #e6e6e6;
                // min-height: 500px;
                .li_f,
                .li_c {
                    box-sizing: border-box;
                    text-overflow: ellipsis;  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/ 
                    white-space: nowrap;   /* nowrap:规定段落中的文本不进行换行   */ 
                    overflow: hidden;
                    width: 100%;
                    line-height: 25px;
                    font-size: 16px;
                    color: #333;
                    float: left;
                    border-bottom: 1px solid rgb(230, 230, 230);
                    padding: 15px;
                    padding-left: 23px;
                    border-left: 7px solid #fff;
                    padding-right: 40px;
                }
                // .li_f:hover,
                .li_c:hover {
                    background: #f5f5f5;
                    color: #023e7a;
                    border-left: 7px solid #023e7a;
                    cursor: pointer;
                }
                .active {
                    background: #f5f5f5;
                    color: #023e7a;
                    border-left: 7px solid #023e7a;
                }
                .li_c {
                    padding-left: 45px;
                }
            }
        }
        .product_details {
            width: 77.5863%;
            float: left;
            padding-left: 3.363%;
            // border-left: 1px solid #e6e6e6;
            margin-left: -1px;
            .product_details_title {
                height: 55px;
                min-height: 55px;
                line-height: 50px;
                border-bottom: 1px solid #f0f0f0;
                margin-bottom: 6px;
                .title_more {
                    float: left;
                    color: #000;
                    text-align: center;
                    font-size: 24px;
                    color: #333;
                    font-weight: bold;
                }
                .more {
                    float: right;
                    font-size: 14px;
                }
            }
            .product_details_content {
                padding: 20px;
            }
        }
    }
}
</style>
